<template>
  <div
    id="echartsId2"
    style="height: 250px; width: 250px; margin: 0 auto"
  ></div>
</template>

<script>
export default {
  methods: {
    chartint() {
      let myChart = this.$echarts.init(document.getElementById("echartsId2"));
      var option;
      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "3%",
          icon: "circle",
          temWidth: 10, // 设置宽度
          itemHeight: 10, // 设置高度
        },
        series: [
          {
            top: "0",
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "40%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1048, name: "周一" },
              { value: 735, name: "周二" },
              { value: 580, name: "周三" },
              { value: 484, name: "周四" },
              { value: 330, name: "周五" },
              { value: 320, name: "周六" },
              { value: 30, name: "周日" },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
  mounted() {
    this.chartint();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/echarts/RefererChart.vue